import { render, staticRenderFns } from "./NoticeModel.vue?vue&type=template&id=467f6ca2"
import script from "./NoticeModel.vue?vue&type=script&lang=js"
export * from "./NoticeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports